import { AppBar, Box, IconButton, Toolbar, useMediaQuery, useTheme } from "@mui/material";
import { Outlet } from "react-router-dom";

import { useEffect, useState } from "react";
import SideMenuBar, { SIDEBAR_BACKGROUND } from "../component/sidemenu/SideMenuBar";
import MenuIcon from "@mui/icons-material/Menu";
import logo from "../assets/images/login.png";
import { CONTENT_MAX_WIDTH, MOBILE_BAR_HEIGHT, PAGE_PADDING } from "../utils/responsive";

const DRAWER_ID = "main-navigation-drawer";

const Layout = () => {
  const [sidebar, setSidebar] = useState(false);
  // Phones and portrait tablets get a drawer; landscape tablets and up keep the permanent sidebar.
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"), { noSsr: true });

  // A drawer left open on a small screen must not stay open after growing to desktop.
  useEffect(() => {
    if (!isMobile) setSidebar(false);
  }, [isMobile]);

  return (
    <Box
      sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f5f5f5" }}
    >
      {/* Sidebar */}
      <SideMenuBar
        sidebar={sidebar}
        setSidebar={setSidebar}
        isMobile={isMobile}
        drawerId={DRAWER_ID}
      />

      {/* Main content area */}
      <Box sx={{ minWidth: 0, flexGrow: 1, display: "flex", flexDirection: "column" }}>
        {/* Top bar with the menu button replaces the sidebar on small screens */}
        {isMobile && (
          <AppBar
            position="sticky"
            elevation={0}
            sx={{
              top: 0,
              backgroundColor: SIDEBAR_BACKGROUND,
              color: "#EAF2FF",
              borderBottom: "1px solid rgba(255, 255, 255, 0.10)",
            }}
          >
            <Toolbar disableGutters sx={{ minHeight: `${MOBILE_BAR_HEIGHT}px !important`, px: 1, gap: 1 }}>
              <IconButton
                onClick={() => setSidebar(true)}
                aria-label="Open navigation menu"
                aria-controls={DRAWER_ID}
                aria-expanded={sidebar}
                sx={{ width: 44, height: 44, color: "inherit" }}
              >
                <MenuIcon />
              </IconButton>
              <Box component="img" src={logo} alt="Police Verification" sx={{ height: 36, width: "auto", maxWidth: "60%", objectFit: "contain" }} />
            </Toolbar>
          </AppBar>
        )}

        {/* Page content */}
        <Box
          component="main"
          sx={{
            padding: PAGE_PADDING,
            flexGrow: 1,
            minWidth: 0,
          }}
        >
          <Box sx={{ width: "100%", maxWidth: CONTENT_MAX_WIDTH, mx: "auto", minWidth: 0 }}>
            <Outlet />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Layout;
